import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ControlLabel, FormGroup, FormControl, Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import DatePicker from 'react-date-picker';
import PropTypes from 'prop-types';

import { updateField } from '../../actions/form';
import { enableSubmit, disableSubmit } from '../../actions/ui';

import FieldTextBox from './FieldTextBox.jsx';
import FieldTextArea from './FieldTextArea.jsx';
import StateComboBox from '../StateComboBox.jsx';
import PhotoUploadForm from './PhotoUploadForm.jsx';
import MeasurementComboBox from '../MeasurementComboBox.jsx';
import validation from '../../lib/validation';

export class PersonalInformationForm extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.hobbyControlLabel = 'Please list any hobbies, passion or interest other than racing.';
    this.requiredFields = ['fullName', 'email', 'birthdate', 'mobileNumber'];

    this.onSelectChange = this.onSelectChange.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.updateStore = _.debounce(this.updateStore, 200);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.profile !== nextProps.profile) {
      this.validateForm(nextProps.profile, nextProps.rules);
    }
  }

  onSelectChange({ target }) {
    const { name: field, value } = target;

    this.updateStore(field, value);
    this.props.updateField('validation.profile', field, 'success');
  }

  validateForm(profile = this.props.profile, rules = this.props.rules) {
    const validForm = _.every(this.requiredFields, (field) => {
      const value = profile[field];
      const rule = rules[field];

      // value and rule haven't loaded yet
      if (_.isUndefined(rule) && _.isUndefined(value)) return false;

      // field is required but it's empty
      if (_.has(rule, 'required') && _.isUndefined(value)) return false;

      // else run validation
      return validation.run(rule, value);
    });

    if (validForm) this.props.enableSubmit();
    else this.props.disableSubmit();
  }

  updateStore(field, value) {
    this.props.updateField('profile', field, value);
  }

  render() {
    return (
      <div className="container-fluid form-container">
        <Row>
          <Col lg={12} className="form-title-container">
            <h1>{this.props.currentUserLevel}</h1>
            <span className="form-title-span">{this.props.name}</span>
            <p className="subtext">All fields marked with an asterisk symbol (*) are mandatory.</p>
          </Col>
        </Row>

        <form id="PersonalInformationForm" autoComplete="off">
          <Row>
            <Col md={12}><FieldTextBox placeholder="* Full Name" field="fullName" /></Col>
          </Row>

          <Row>
            <Col md={6} sm={12}><FieldTextBox placeholder="* Email" field="email" /></Col>
            <Col md={6} sm={12}><FieldTextBox placeholder="* Phone #" field="mobileNumber" /></Col>
          </Row>

          <Row>
            <Col md={6}>
              <FormGroup id="birthdateGroup" validationState={this.props.validation.birthdate} controlId="driverBirthdateInput">
                <DatePicker
                  onChange={e => this.onSelectChange({ target: { name: 'birthdate', value: e } })}
                  value={this.props.profile.birthdate}
                  clearIcon={null}
                  required
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>

            <Col md={6}><FieldTextBox placeholder="Birthplace" field="birthplace" /></Col>
          </Row>

          <Row>
            <Col md={6}><FieldTextBox placeholder="Mailing Address" field="mailingAddress" /></Col>

            <Col md={3}>
              <FormGroup validationState={this.props.validation.mailingAddressState} className="dropdownSelect" controlId="driverMailingAddressStateInput">
                <StateComboBox
                  name="mailingAddressState"
                  selected={_.get(this.props, 'profile.mailingAddressState', '')}
                  onChange={this.onSelectChange}
                />
                <FormControl.Feedback className="select-feedback" />
                <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
              </FormGroup>
            </Col>

            <Col md={3}><FieldTextBox placeholder="ZIP Code" field="mailingAddressZip" /></Col>
          </Row>

          <Row>
            <Col md={6}><FieldTextBox placeholder="Residential Address" field="residentialAddress" /></Col>

            <Col md={3}>
              <FormGroup validationState={this.props.validation.residentialAddressState} className="dropdownSelect" controlId="driverResidentialAddressStateInput">
                <StateComboBox
                  name="residentialAddressState"
                  selected={_.get(this.props, 'profile.residentialAddressState', '')}
                  onChange={this.onSelectChange}
                />
                <FormControl.Feedback className="select-feedback" />
                <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
              </FormGroup>
            </Col>

            <Col md={3}><FieldTextBox placeholder="ZIP Code" field="residentialAddressZip" /></Col>
          </Row>

          <Row>
            <Col md={3}><FieldTextBox placeholder="Facebook URL" field="facebook" /></Col>
            <Col md={3}><FieldTextBox placeholder="Instagram URL" field="instagram" /></Col>
            <Col md={3}><FieldTextBox placeholder="Twitter URL" field="twitter" /></Col>
            <Col md={3}><FieldTextBox placeholder="Website URL" field="website" /></Col>
          </Row>

          <Row>
            <Col md={3}><FieldTextBox placeholder="Height ex. 6 ft 1 in" field="height" /></Col>
            <Col md={3}><FieldTextBox placeholder="Weight ex. 190 lbs" field="weight" /></Col>
            <Col md={3}><FieldTextBox placeholder="Helmet Size" field="helmetSize" /></Col>
            <Col md={3}><FieldTextBox placeholder="Glove Size" field="gloveSize" /></Col>
          </Row>

          <Row>
            <Col md={3}><FieldTextBox placeholder="Shoe Size" field="shoeSize" /></Col>

            <Col md={3}>
              <FormGroup validationState={this.props.validation.hatSize} className="dropdownSelect" controlId="driverhatSizeInput">
                <MeasurementComboBox
                  name="hatSize"
                  displayName="Hat Size"
                  selected={this.props.profile.hatSize}
                  measurements={['S', 'M', 'L', 'XL']}
                  onChange={this.onSelectChange}
                />
                <FormControl.Feedback className="select-feedback" />
                <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup validationState={this.props.validation.shirtSize} className="dropdownSelect" controlId="drivershirtSizeInput">
                <MeasurementComboBox
                  name="shirtSize"
                  displayName="T-Shirt/Polo Size"
                  selected={this.props.profile.shirtSize}
                  onChange={this.onSelectChange}
                />
                <FormControl.Feedback className="select-feedback" />
                <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup validationState={this.props.validation.jacketSize} className="dropdownSelect" controlId="driverjacketSizeInput">
                <MeasurementComboBox
                  name="jacketSize"
                  displayName="Jacket Size"
                  selected={this.props.profile.jacketSize}
                  onChange={this.onSelectChange}
                />
                <FormControl.Feedback className="select-feedback" />
                <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={4}><FieldTextBox placeholder="LLC Name" field="llcName" /></Col>
            <Col md={4}><FieldTextBox placeholder="Health INS" field="healthIns" /></Col>
            <Col md={4}><FieldTextBox placeholder="Workers Comp INS" field="workersComp" /></Col>
          </Row>

          <Row>
            <Col md={6}><FieldTextBox placeholder="LLC Address" field="llcAddress" /></Col>

            <Col md={3}>
              <FormGroup validationState={this.props.validation.llcAddressState} className="dropdownSelect" controlId="driverLLCAddressStateInput">
                <StateComboBox
                  name="llcAddressState"
                  selected={_.get(this.props, 'profile.llcAddressState', '')}
                  onChange={this.onSelectChange}
                />
                <FormControl.Feedback className="select-feedback" />
                <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
              </FormGroup>
            </Col>

            <Col md={3}><FieldTextBox placeholder="ZIP Code" field="llcAddressZip" /></Col>
          </Row>

          <Row>
            <Col md={12}><FieldTextArea placeholder={this.hobbyControlLabel} field="hobbies" /></Col>
          </Row>

        </form>

        <PhotoUploadForm rules={this.props.rules} />
      </div>
    );
  }
}

export const mapStateToProps = state => ({
  loading: state.form.profile.loading,
  profile: state.form.profile.fields,
  validation: state.form.validation.profile.fields,
});

export default connect(
  mapStateToProps,
  { enableSubmit, disableSubmit, updateField },
)(PersonalInformationForm);

PersonalInformationForm.propTypes = {
  name: PropTypes.string,
  rules: PropTypes.object,
};
